'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemFacetsIfNeeded = exports.isItemFacetsLoading = exports.getLoadTimeForItemFacets = exports.getItemFacets = exports.LOAD_ITEM_FACETS_SUCCESS = exports.LOAD_ITEM_FACETS_REQUEST = exports.LOAD_ITEM_FACETS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_FACETS_FAIL = exports.LOAD_ITEM_FACETS_FAIL = 'la/domain/itemFacet/LOAD_FAIL';
var LOAD_ITEM_FACETS_REQUEST = exports.LOAD_ITEM_FACETS_REQUEST = 'la/domain/itemFacet/LOAD_REQUEST';
var LOAD_ITEM_FACETS_SUCCESS = exports.LOAD_ITEM_FACETS_SUCCESS = 'la/domain/itemFacet/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_FACETS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEM_FACETS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ITEM_FACETS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            (0, _cloneDeep2.default)(action.payload).forEach(function (facets) {
                var itemId = facets.itemId;

                delete facets.itemId;
                existing[itemId] = (0, _extends3.default)({}, facets);
                loaded[itemId] = time;
                loading = (0, _difference2.default)(loading, [itemId]);
            });

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemFacets;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getItemFacets = exports.getItemFacets = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _cloneDeep2.default)(byId[id]) || {};
});

var getLoadTimeForItemFacets = exports.getLoadTimeForItemFacets = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemFacetsLoading = exports.isItemFacetsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemFacets = function shouldFetchItemFacets(state, itemId) {
    var data = getItemFacets(state, itemId);
    if (!(0, _isEmpty2.default)(data)) {
        var loaded = getLoadTimeForItemFacets(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemFacetsLoading(state, itemId);
    return !loading;
};

var whichItemFacetsNeeded = function whichItemFacetsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemFacets(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemFacetsFail = function loadItemFacetsFail(itemIds, error) {
    return {
        error: true,
        meta: { itemIds: itemIds },
        payload: error,
        type: LOAD_ITEM_FACETS_FAIL
    };
};

var loadItemFacetsRequest = function loadItemFacetsRequest(itemIds) {
    return {
        payload: itemIds,
        type: LOAD_ITEM_FACETS_REQUEST
    };
};

var loadItemFacetsSuccess = function loadItemFacetsSuccess(itemIds, results) {
    return {
        meta: { actionTime: Date.now(), itemIds: itemIds },
        payload: results,
        type: LOAD_ITEM_FACETS_SUCCESS
    };
};

var loadItemFacets = function loadItemFacets(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadItemFacetsRequest(itemIds));
        return _api.ItemFacets.fetchItemFacets({ deployment: deployment, ids: itemIds }).then(function (response) {
            dispatch(loadItemFacetsSuccess(itemIds, response.data));
        }).catch(function (error) {
            dispatch(loadItemFacetsFail(itemIds, error));
        });
    };
};

var fetchItemFacetsIfNeeded = exports.fetchItemFacetsIfNeeded = function fetchItemFacetsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var neededItems = whichItemFacetsNeeded(getState(), itemIds);
        if (neededItems.length) {
            return dispatch(loadItemFacets(neededItems));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/itemFacets.js
// module id = WWzX
// module chunks = 46